import React, {
    Fragment,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { AppContext } from "../context";
import loading from "../img/loading.gif";
import ReactDOM from "react-dom/client";
import hand from "../components/Stencils/hold.svg";
import * as tf from "@tensorflow/tfjs";
import {
    setBackendExternally,
} from "../partdetection_new/PartDetector";
import {
    addImageToList,
    setLog,
    userLogs,
    patLogs,
    setSubCompleted,
    getSubCompleted,
    setSubMandatoryCompleted,
    getSubMandatoryCompleted,
    getKotakRecaptureCase,
    setKotakRecapMenuSection,
    setKotakRecapSubSection,
    getKotakRecapSubSection,
    getConstraint,
    getAspectRatioClientList,
    imageFeedbackLambda,
    getModel,
    setVideoFlag,
    getVideoFlag,
    getDectectLabels,
    getCheckSectionAllowFlag,
    setCheckSectionAllowFlag,
    getPartDetector,
    getGuidance,
    setCaptureFlag,
    getCaptureFlag,
    getModalResult,
    getLambdaResult,
    setLambdaResult,
    setModalResult,
    blurLumaLambda,
    imageVerficationModal,
    setAngleFlag,
    getWebpImageFormat,
    getImgQualityFactor
} from "../context/utils";
import cameraImg from "../img/camera.png";
import Button from "./Button";
import Rotate from "./Rotate";
import leftArrow from "../img/left.png";
import rightArrow from "../img/right.png";
import car_inspection from "../img/car_inspection.png";
import white_tick from "../img/white_tick.png";
import { goodFrame, regionAndPartsVerification } from "../guidance_new/ImgFeedback"
import zizo_arrow from "../img/zizo_arrow.gif";

import Front from "./Stencils/car/Front";
import Front_Isometric_Left from "./Stencils/car/Front-Isometric-Left";
import Front_Isometric_Right from "./Stencils/car/Front-Isometric-Right";
import Side_Left from "./Stencils/car/Side-Left";
import Side_Right from "./Stencils/car/Side-Right";
import Rear from "./Stencils/car/Rear";
import Rear_Isometric_Right from "./Stencils/car/Rear-Isometric-Right";
import Rear_Isometric_Left from "./Stencils/car/Rear-Isometric-Left";
import SafeImage from "./SafeImage";
import { startVideoPlayback } from "../utils_new/videoPlayback";

let logBugs = true;
let currentSubBlock = "";
let currentTag = "";
let imageCaptured = false;
let image = {};
let alignment = false;
let mandatoryMissing = [];
let subMissing = [];
let cameraStarted = false;
let track = null;
let reservedData = null;
let detectMlCheck = true;
let timeout1, timeout2;
let videoEl;
let detectionTemp;
let predictionsTemp;
let sampleUrl;
let analysisInterval = null;
let timeOutInterval = null;
let rearrangeFlag = true;
let frameCount = 0;
let angle = "_START_";
let allowSectionAtFirst = [0, 1, 2, 3];
let captureList = ["Front Capture", "Front Left", "Left Capture", "Back Left", "Back Capture", "Back Right", "Right Capture", "Front Right"];
let region = [{ "Front Capture": "Front" }, { "Back Capture": "Rear" }, { "Left Capture": "Side-Left" }, { "Right Capture": "Side-Right" }, { "Front Left": "Front-Isometric-Left" }, { "Front Right": "Front-Isometric-Right" }, { "Back Left": "Rear-Isometric-Left" }, { "Back Right": "Rear-Isometric-Right" }];
let ComponentToRender;
let currentStencil = "";
let regionStencil = {
    Front: Front,
    "Front-Isometric-Left": Front_Isometric_Left,
    "Side-Left": Side_Left,
    "Rear-Isometric-Left": Rear_Isometric_Left,
    Rear: Rear,
    "Rear-Isometric-Right": Rear_Isometric_Right,
    "Side-Right": Side_Right,
    "Front-Isometric-Right": Front_Isometric_Right,
};

const NewImgApp = () => {
    const {
        stepCovered,
        setStepCovered,
        clientId,
        showAlert,
        condition,
        setCondition,
        setScreen,
        currentBlock,
        showOptions,
        setShowOptions,
        config,
        isLandscape,
        setLandscape,
        mandatory,
        setMandatory,
        subMandatory,
        setSubMandatory,
        setCurrentPage,
        inspectionId,
        subCondition,
        setSubCondition,
        count1,
        setCount1,
        scrollX,
        setscrollX,
        scrolEnd,
        setscrolEnd,
        isIOS
    } = useContext(AppContext);

    const land = () => window.innerWidth > window.innerHeight * 1.2;
    const [color, setColor] = useState("#fff")
    const [instructions, setInstructions] = useState(null);
    const [feedback, setFeedback] = useState([]);
    const [resultFlag, setResultFlag] = useState(false);
    const [guidanceText, setGuidanceText] = useState("");
    const [showBox, setShowBox] = useState(false);
    const [currentBlockItem, setCurrentBlockItem] = useState(
        currentBlock["values"]
    );

    window.onresize = () => {
        setLandscape(land());
        if (!land()) {
            setVideoFlag(false);
            cameraStarted = false;
            setShowBox(false);
            clearTimeout(timeout1);
            clearTimeout(timeout2);
            clearTimeout(timeOutInterval);
        }
        else if (land()) {
            if (!cameraStarted) startCamera();
        }
    };

    const getTranslateText = (text) => {
        if (Object.keys(config["language"]).includes(text)) {
            return config["language"][text];
        } else {
            // const data = translateText(text, config["language"]["langCode"]);
            return text;
        }
    };

    const [reduce, setReduce] = useState(false);
    if (logBugs) {
        logBugs = false;
        patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
        userLogs({
            position: 8,
            last_page: `${currentBlock.tag} Module`,
            inspectionId,
        });
    }

    let model = null;
    let webCamPromise = null;
    const cardRef = useRef();
    const pRef = useRef();
    const singleScreen = useRef();
    const videoRef = useRef();
    const canvasRef = useRef();
    const startBtn = useRef();
    const imgRef = useRef();
    const modalRef = useRef();
    const divImgRef = useRef();
    let scrl = useRef();
    const feedBackPopUp = useRef();
    const redLineVINcontainer = useRef();
    const guidanceArrow = useRef();
    const leftArrowGuidance = useRef();
    const rightArrowGuidance = useRef();
    const stopHand = useRef();
    const imageContainer = useRef();
    const noFeedbackPop = useRef();
    const feedbackHeadText = useRef();
    const pTagRef = useRef();
    const detectionBox = useRef();
    const warningRef = useRef();
    const stencilBoxRef = useRef();
    const stencilImageDiv = useRef();
    const rootRef = useRef(null);
    const partData = useRef()

    // const stencilResize = () => {
    //     requestAnimationFrame(() => {
    //         const containerWidth = window.innerWidth;
    //         const containerHeight = window.innerHeight;

    //         const videoAspect = videoEl.videoWidth / videoEl.videoHeight;
    //         const containerAspect = containerWidth / containerHeight;

    //         let displayWidth, displayHeight;

    //         if (videoAspect > containerAspect) {
    //             // Video is wider — full width, black bars top/bottom
    //             displayWidth = containerWidth;
    //             displayHeight = containerWidth / videoAspect;
    //         } else {
    //             // Video is taller — full height, black bars sides
    //             displayHeight = containerHeight;
    //             displayWidth = containerHeight * videoAspect;
    //         }

    //         // Apply box size and position
    //         if (stencilBoxRef?.current) {
    //             const box = stencilBoxRef.current;
    //             box.style.width = `${displayWidth}px`;
    //             box.style.height = `${displayHeight}px`;
    //             box.style.left = `${(containerWidth - displayWidth) / 2}px`;
    //             if (["Left Capture", "Right Capture"].includes(currentTag)) box.style.top = "40%";
    //             else box.style.top = `${(containerHeight - displayHeight) / 2}px`;
    //             box.style.position = "absolute";
    //             box.style.display = "flex";
    //             box.style.pointerEvents = "none";
    //         }

    //         // Show buttons/overlays
    //     });
    // };

    const startCamera = () => {
        try {
            if (timeOutInterval) clearTimeout(timeOutInterval);
            setGuidanceText("Calculating angle. Please point the camera at the car.");
            setFeedback([]);
            setColor("#fff");
            setResultFlag(false);
            angle = "_START_";
            setModalResult(null);
            frameCount = 0;
            reservedData = null;
            if (feedBackPopUp.current && feedBackPopUp.current.style.display === "flex") feedBackPopUp.current.style.display = "none";
            if (noFeedbackPop.current && noFeedbackPop.current.style.display === "flex") noFeedbackPop.current.style.display = "none";
            webCamPromise = navigator.mediaDevices
                .getUserMedia(getConstraint(config, clientId))
                .then((stream) => {
                    window.stream = stream;
                    track = stream.getTracks()[0];

                    videoEl = videoRef.current;
                    videoEl.srcObject = stream;
                    startVideoPlayback(videoEl, config);

                    videoEl.onloadedmetadata = () => {
                        cameraStarted = true;
                        // if (config["showStencil"]) stencilResize();
                        if (startBtn.current) startBtn.current.style.display = "none";
                        if (redLineVINcontainer.current) redLineVINcontainer.current.style.display = "flex";
                        if (stopHand.current) stopHand.current.style.display = "none";
                        if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
                            currentStencil = region.find(item => item[currentTag] !== undefined)?.[currentTag];
                            ComponentToRender = regionStencil[currentStencil];
                            // console.log("current sTENCIL VALUE", currentStencil);
                            if (currentStencil && currentStencil !== "") {
                                if (stencilImageDiv.current) {
                                    stencilImageDiv.current.style.display = "flex";
                                    stencilImageDiv.current.style.border = "2px solid red";
                                    setupVideoWithStencilBox(currentStencil);
                                    if (!rootRef.current) {
                                        rootRef.current = ReactDOM.createRoot(stencilImageDiv.current);
                                        rootRef.current.render(<ComponentToRender strokeColor="#fff" />);
                                    }
                                }
                            }
                        }
                        setTimeout(() => {
                            setVideoFlag(true);
                            setCaptureFlag(true);
                            setShowBox(true);
                            startRecording();
                        }, 500);
                    };
                });
        } catch (err) {
            // console.log(err);
        }
    };

    const setupVideoWithStencilBox = (currentRegion) => {
        const videoEl = videoRef.current;
        if (!videoEl) return;
        requestAnimationFrame(() => {
            const containerWidth = window.innerWidth;
            const containerHeight = window.innerHeight;

            const videoAspect = videoEl.videoWidth / videoEl.videoHeight;
            const containerAspect = containerWidth / containerHeight;

            let displayWidth, displayHeight;

            if (videoAspect > containerAspect) {
                displayWidth = containerWidth;
                displayHeight = containerWidth / videoAspect;
            } else {
                displayHeight = containerHeight;
                displayWidth = containerHeight * videoAspect;
            }

            if (stencilImageDiv?.current) {
                const box = stencilImageDiv.current;
                Object.assign(box.style, {
                    width: `${displayWidth - 40}px`,
                    height: ["Side-Left", "Side-Right"].includes(currentRegion)
                        ? `${displayHeight - 45}px`
                        : `${displayHeight - 40}px`,
                    left: `${(containerWidth - displayWidth) / 2 + 20}px`,
                    top: ["Side-Left", "Side-Right"].includes(currentRegion)
                        ? `${(containerHeight - displayHeight) / 2 + 22.5}px`
                        : `${(containerHeight - displayHeight) / 2 + 20}px`,
                    position: "absolute",
                    display: "flex",
                    pointerEvents: "none",
                });
            }
        });
    };

    const sendLogData = async (data) => {
        userLogs(data);
    };

    const startRecording = () => {
        if (cardRef.current) cardRef.current.style.display = "flex";
        Promise.all([getModel(), webCamPromise])
            .then((values) => {
                sendLogData({
                    position: 6,
                    model_initialized: "yes",
                    inspectionId,
                });
                model = values[0];
                detectFrame(videoRef.current, model);
                setCurrentPage("Model initialize");
                timeout1 = setTimeout(() => {
                    if (cardRef.current) cardRef.current.style.display = "none";
                }, 10000);
                timeout2 = setTimeout(() => {
                    setCaptureFlag(false);
                    setShowBox(false);
                    setColor("green");
                    analysingFeedback();
                    if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
                        if (rootRef.current) {
                            rootRef.current.unmount();
                            rootRef.current = null;
                        }
                        if (!rootRef.current) {
                            rootRef.current = ReactDOM.createRoot(
                                stencilImageDiv.current
                            );
                            rootRef.current.render(
                                <ComponentToRender strokeColor="#90EE90" />
                            );
                        }
                    }
                    if (cardRef.current) cardRef.current.style.display = "none";
                    setGuidanceText(getTranslateText("Please hold on. You are standing at the right distance. Please take a photo."));
                    if (startBtn.current) startBtn.current.style.display = "block";
                    if (redLineVINcontainer.current) {
                        redLineVINcontainer.current.style.bottom = "22%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                        if (stopHand.current) stopHand.current.style.display = "flex";
                    }
                }, 25000);
            })
            .catch((error) => {
                // console.log(error);
                sendLogData({
                    position: 6,
                    model_initialized: `no - ${error.message}`,
                    inspectionId,
                });
                setCurrentPage("Model not initialize");
            });
    };

    const captureImg = () => {
        // patLogs("capture image button clicked", inspectionId);
        setVideoFlag(false);
        setAngleFlag(true);
        setShowBox(false);
        analysingFeedback();
        const cnv = canvasRef.current;
        const vw = videoRef.current;
        cnv.width = vw.videoWidth;
        cnv.height = vw.videoHeight;
        cnv.getContext("2d").drawImage(vw, 0, 0);
        const imgData = getWebpImageFormat() && !isIOS
            ? cnv.toDataURL("image/webp", getImgQualityFactor())
            : cnv.toDataURL("image/jpeg");
        divImgRef.current.src = imgData;
        reservedData = imgData;
        let region1 = Object.keys(config["video-page"]).includes("clientRegion")
            ? config["video-page"]["clientRegion"]
            : "eu";
        image = {
            name: `${currentTag}.jpg`,
            imgData: imgData,
            tag: `${currentBlock.tag}: ${currentTag}`,
            web_region: null,
            angle: null,
            region: region1,
            videoData: null,
            dialStatus: null,
            currentTag,
            currentBlockName: currentBlock["id"],
            currentSubBlock
        };
        if (redLineVINcontainer.current) redLineVINcontainer.current.style.display = "none";
        imgRef.current.style.display = "block";
        if (!resultFlag) feedBackPopUp.current.style.display = "flex";
        else {
            if (feedback.length === 0) {
                noFeedbackPop.current.style.display = "flex";
            }
            else feedBackPopUp.current.style.display = "flex";
        }
        if (feedback.length === 0 && !resultFlag) feedbackHeadText.current.innerHTML = getTranslateText("Hold on, we’re analyzing the image...");
        else if (feedback.length > 0 && resultFlag) feedbackHeadText.current.innerHTML = getTranslateText("❗The captured image needs improvement");
    };

    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
        setscrollX(scrollX + shift);
        if (
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const scrollCheck = () => {
        setscrollX(scrl.current.scrollLeft);
        if (
            Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth
        ) {
            setscrolEnd(true);
        } else {
            setscrolEnd(false);
        }
    };

    const imageRetake = () => {
        // patLogs("retake button clicked to capture image again", inspectionId);
        if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
            if (rootRef.current) {
                rootRef.current.unmount();
                rootRef.current = null;
            }
        }
        if (feedBackPopUp.current.style.display === "flex") feedBackPopUp.current.style.display = "none";
        if (noFeedbackPop.current.style.display === "flex") noFeedbackPop.current.style.display = "none";
        imgRef.current.style.display = "none";
        startCamera();
    };

    const goBack = () => {
        if (timeOutInterval) clearTimeout(timeOutInterval);
        // if (stencilBoxRef?.current) {
        //     stencilBoxRef.current.style.display = "none";
        // }
        if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
            if (rootRef.current) {
                rootRef.current.unmount();
                rootRef.current = null;
            }
        }
        setVideoFlag(false);
        setShowBox(false);
        cameraStarted = false;
        setSubCompleted(false);
        setSubMandatoryCompleted(false);
        currentSubBlock = "";
        currentTag = "";
        alignment = false;
        setScreen("menu");
    };

    const removeModal = () => {
        if (modalRef && modalRef.current) modalRef.current.style.display = "none";
    };

    const captureImgFrame = (byPassBlack) => {
        if (getVideoFlag()) {
            try {
                const cnv = canvasRef.current;
                const vw = videoRef.current;
                cnv.width = vw.videoWidth;
                cnv.height = vw.videoHeight;

                const ctx = cnv.getContext("2d");
                ctx.drawImage(vw, 0, 0);
                const imageData = ctx.getImageData(0, 0, cnv.width, cnv.height);
                const { data, width, height } = imageData;

                let blackPixelCount = 0;
                for (let i = 0; i < data.length; i += 4) {
                    const [r, g, b] = [data[i], data[i + 1], data[i + 2]];
                    const brightness = (r + g + b) / 3;
                    if (brightness < 5) {
                        blackPixelCount++;
                    }
                }

                const totalPixels = width * height;
                const blackPercentage = (blackPixelCount / totalPixels) * 100;

                return byPassBlack || blackPercentage < 100
                    ? getWebpImageFormat() && !isIOS
                        ? cnv.toDataURL("image/webp", getImgQualityFactor())
                        : cnv.toDataURL("image/jpeg")
                    : false;
            }
            catch (err) {
                // console.log(err);
                return false;
            }
        }
        else return false;
    };

    const analysingFeedback = async () => {
        let tempfeedback = [];
        imageVerficationModal(region, currentTag, detectionTemp, angle);
        let currentRegion = region.find(item => item[currentTag] !== undefined)?.[currentTag];
        let obj = { "lbls": Array.from(getDectectLabels()), angle, currentRegion };
        pTagRef.current.innerHTML = JSON.stringify(obj);

        // analysisInterval = setInterval(() => {
        //     console.log("niranjan lambda inter :::  ", getLambdaResult());
        //     console.log("salmaan sir result inter :::  ", getModalResult());
        //     if (getLambdaResult() !== null && getModalResult() !== null) {
        //         clearInterval(analysisInterval);
        //         clearTimeout(timeOutInterval);
        //         setResultFlag(true);
        //         let lambdaResult = getLambdaResult(), modalResult = getModalResult();
        //         if (lambdaResult["blur_luma"] && (lambdaResult["blur_luma"][0] !== 0 && lambdaResult["blur_luma"][1] !== 0)) {
        //             if ([1, 2].includes(lambdaResult["blur_luma"][1])) {
        //                 tempfeedback.push(Object.keys(config["imageFeedback"]["ReasonMssg"]).includes("The image was captured in low light condition.") ? config["imageFeedback"]["ReasonMssg"]["The image was captured in low light condition."] : getTranslateText("The image was captured in low light condition."));
        //             }
        //             if ([5].includes(lambdaResult["blur_luma"][0]) && tempfeedback.length === 0) {
        //                 tempfeedback.push(Object.keys(config["imageFeedback"]["ReasonMssg"]).includes("The image captured was blurry.") ? config["imageFeedback"]["ReasonMssg"]["The image captured was blurry."] : getTranslateText("The image captured was blurry."));
        //             }
        //         }
        //         if (tempfeedback.length === 0) {
        //             if (!modalResult.region_flag) {
        //                 let tag = currentTag.slice(" ")[1] === "Capture" ? currentTag.slice(" ")[0] : currentTag;
        //                 let finalTag = Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(tag + " side") ? config["imageFeedback"]["ReasonMssg"][tag + " side"] : getTranslateText(tag);
        //                 tempfeedback.push(getTranslateText("The captured image does not belong to the # of the car").replace("#", finalTag));
        //             }
        //             else if (modalResult.region_flag && !modalResult.complete_part_flag) {
        //                 let partList = modalResult.undetected_part_list.map(e => ["running_board", "window_glass"].includes(e) ? getTranslateText(e) : Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(e) ? config["imageFeedback"]["ReasonMssg"][e] : getTranslateText(e))
        //                 tempfeedback.push(getTranslateText("Following part(s) were not captured properly: #. Please capture again").replace('#', partList.join(", ")));
        //             }
        //         }
        //         if (tempfeedback.length > 0) {
        //             if (feedbackHeadText.current) feedbackHeadText.current.innerHTML = getTranslateText("❗The captured image needs improvement");
        //             setFeedback(tempfeedback);
        //         }
        //         else {
        //             clearInterval(analysisInterval);
        //             clearTimeout(timeOutInterval);
        //             setCheckSectionAllowFlag(false);
        //             if (redLineVINcontainer.current && reservedData) redLineVINcontainer.current.style.display = "none";
        //             if (feedBackPopUp.current && feedBackPopUp.current.style.display === "flex") feedBackPopUp.current.style.display = "none";
        //             if (reservedData) noFeedbackPop.current.style.display = "flex";
        //         }
        //     }
        // }, 500);
        timeOutInterval = setTimeout(() => {
            setResultFlag(true);
            // console.log("niranjan lambda :::  ", getLambdaResult());
            // console.log("salmaan sir result :::  ", getModalResult());
            let lambdaResult = getLambdaResult(), modalResult = getModalResult();
            if (lambdaResult !== null && lambdaResult["blur_luma"] && (lambdaResult["blur_luma"][0] !== 0 && lambdaResult["blur_luma"][1] !== 0)) {
                if ([1, 2].includes(lambdaResult["blur_luma"][1])) {
                    tempfeedback.push(Object.keys(config["imageFeedback"]["ReasonMssg"]).includes("The image was captured in low light condition.") ? config["imageFeedback"]["ReasonMssg"]["The image was captured in low light condition."] : getTranslateText("The image was captured in low light condition."));
                }
                if ([5].includes(lambdaResult["blur_luma"][0]) && tempfeedback.length === 0) {
                    tempfeedback.push(Object.keys(config["imageFeedback"]["ReasonMssg"]).includes("The image captured was blurry.") ? config["imageFeedback"]["ReasonMssg"]["The image captured was blurry."] : getTranslateText("The image captured was blurry."));
                }
            }
            if (tempfeedback.length === 0) {
                if (!modalResult.region_flag) {
                    let tag = currentTag.slice(" ")[1] === "Capture" ? currentTag.slice(" ")[0] : currentTag;
                    let finalTag = Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(tag + " side") ? config["imageFeedback"]["ReasonMssg"][tag + " side"] : getTranslateText(tag);
                    tempfeedback.push(getTranslateText("The captured image does not belong to the # of the car").replace("#", finalTag));
                }
                else if (modalResult.region_flag && !modalResult.complete_part_flag) {
                    let partList = modalResult.undetected_part_list.map(e => ["running_board", "window_glass"].includes(e) ? getTranslateText(e) : Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(e) ? config["imageFeedback"]["ReasonMssg"][e] : getTranslateText(e))
                    tempfeedback.push(getTranslateText("Following part(s) were not captured properly: #. Please capture again").replace('#', partList.join(", ")));
                }
            }
            if (tempfeedback.length > 0) {
                if (feedbackHeadText.current) feedbackHeadText.current.innerHTML = getTranslateText("❗The captured image needs improvement");
                setFeedback(tempfeedback);
            }
            else {
                setCheckSectionAllowFlag(false);
                if (redLineVINcontainer.current && reservedData) redLineVINcontainer.current.style.display = "none";
                if (feedBackPopUp.current && feedBackPopUp.current.style.display === "flex") feedBackPopUp.current.style.display = "none";
                if (reservedData) noFeedbackPop.current.style.display = "flex";
            }
        }, 5000);
    };

    // const drawBoxWithDiv = (topLeft, bottomRight) => {
    //     const scaleX = 128 / window.innerWidth;
    //     const scaleY = 128 / window.innerHeight;
    //     const topLeftScaled = topLeft;
    //     const bottomRightScaled = bottomRight;

    //     const originalTopLeft = [
    //         topLeftScaled[0] / scaleX - window.scrollX,
    //         topLeftScaled[1] / scaleY - window.scrollY,
    //     ];

    //     const originalBottomRight = [
    //         bottomRightScaled[0] / scaleX - window.scrollX,
    //         bottomRightScaled[1] / scaleY - window.scrollY,
    //     ];

    //     if (detectionBox.current && getVideoFlag()) detectionBox.current.style.display = "flex";
    //     if (!getVideoFlag() && detectionBox.current) detectionBox.current.style.display = "none !important";
    //     const [x1, y1] = originalTopLeft;
    //     const [x2, y2] = originalBottomRight;

    //     const width = x2 - x1;
    //     const height = y2 - y1;

    //     if (detectionBox.current) {
    //         const box = detectionBox.current;
    //         box.style.position = "absolute";
    //         box.style.left = `${x1}px`;
    //         box.style.top = `${y1}px`;
    //         box.style.width = `${width}px`;
    //         box.style.height = `${height}px`;
    //         box.style.border = "2px solid blue";
    //         box.style.boxSizing = "border-box";
    //     }
    // };

    // function renderRegion() {
    //     switch (region.find(item => item[currentTag] !== undefined)?.[currentTag]) {
    //         case 'Front':
    //             return <Front strokeColor={color} />;
    //         case 'Front-Isometric-Left':
    //             return <Front_Isometric_Left strokeColor={color} />;
    //         case 'Side-Left':
    //             return <Side_Left strokeColor={color} />;
    //         case 'Rear-Isometric-Left':
    //             return <Rear_Isometric_Left strokeColor={color} />;
    //         case 'Rear':
    //             return <Rear strokeColor={color} />;
    //         case 'Rear-Isometric-Right':
    //             return <Rear_Isometric_Right strokeColor={color} />;
    //         case 'Side-Right':
    //             return <Side_Right strokeColor={color} />;
    //         case 'Front-Isometric-Right':
    //             return <Front_Isometric_Right strokeColor={color} />;
    //         default:
    //             return null;
    //     }
    // }

    const drawBoxWithDiv = (topLeft, bottomRight, color) => {
        const scaleX = 128 / window.innerWidth;
        const scaleY = 128 / window.innerHeight;

        const originalTopLeft = [
            topLeft[0] / scaleX - window.scrollX,
            topLeft[1] / scaleY - window.scrollY,
        ];

        const originalBottomRight = [
            bottomRight[0] / scaleX - window.scrollX,
            bottomRight[1] / scaleY - window.scrollY,
        ];
        detectionBox.current.style.display = "flex";
        const [x1, y1] = originalTopLeft;
        const [x2, y2] = originalBottomRight;

        const width = x2 - x1;
        const height = y2 - y1;

        // Create a new box div
        const box = document.createElement("div");
        box.style.position = "absolute";
        box.style.left = `${x1}px`;
        box.style.top = `${y1}px`;
        box.style.width = `${width}px`;
        box.style.height = `${height}px`;
        box.style.border = `2px solid ${color}`;
        box.style.boxSizing = "border-box";

        // Append to container
        detectionBox.current.appendChild(box);
    };


    const detectFrame = async (video, model) => {
        const newImgURL = captureImgFrame(false);
        if (newImgURL) {
            tf.engine().startScope();
            try {
                if (detectMlCheck) {
                    detectMlCheck = false;
                    patLogs("part_detection_is_working", inspectionId);
                }
                if (cardRef.current) cardRef.current.style.display = "none";
                const processedFrame = getPartDetector().processInput(video);
                const predictions = await model.executeAsync(processedFrame);
                const detections = getPartDetector().getDetectionObjects(predictions);
                if (detectionBox.current) {
                    detectionBox.current.innerHTML = "";
                }
                // }
                let xmin = Infinity,
                    ymin = Infinity;
                let xmax = -Infinity,
                    ymax = -Infinity;

                detections.forEach((det) => {
                    const [x1, y1, w, h] = det.bbox;
                    const x2 = x1 + w;
                    const y2 = y1 + h;

                    xmin = Math.min(xmin, x1);
                    ymin = Math.min(ymin, y1);
                    xmax = Math.max(xmax, x2);
                    ymax = Math.max(ymax, y2);
                });
                drawBoxWithDiv([xmin * 128, ymin * 128], [xmax * 128, ymax * 128], "green");
                detections.forEach((det) => {
                    const [x, y, w, h] = det.bbox;
                    drawBoxWithDiv([x * 128, y * 128], [x * 128 + w * 128, y * 128 + h * 128], "blue");
                })
                if (getVideoFlag()) setAngleFlag(false);
                let resulltAngle = getGuidance().performChecksAndGetWarningMessage(
                    detections,
                    processedFrame,
                    newImgURL,
                    // "" and not omitted: the region fallback tests for ""
                    // exactly, and undefined does not match it.
                    ""
                );
                partData.current.innerHTML = JSON.stringify({
                    "rf Angle": resulltAngle[11],
                    "normal gyro angle": resulltAngle[10],
                    "new logic gyro angle": resulltAngle[0],
                });
                // let angleRF = guidance.getAngleOfFeedbackImage(detections);
                // let resulltAngle = getGuidance().getAngleOfViewGyro(detections);
                angle = resulltAngle[0];
                let obj = { "angle": angle };
                if (pRef.current) pRef.current.innerHTML = JSON.stringify(obj);
                // console.log("detection & angle : ", detections, angle)
                if (getVideoFlag()) {
                    detectionTemp = detections;
                    // predictionsTemp = processedFrame;
                    // sampleUrl = newImgURL;
                }
                if (getCheckSectionAllowFlag()) {
                    const detectedLabels = new Set(
                        detections
                            .map(d => d.label)
                            .filter(label => !!label)
                    );
                    if (detectedLabels.size >= 2) {
                        ++frameCount;
                    }
                }

                let [result, bbox, xData, yData, currentRegion] = goodFrame(detections ? detections : detectionTemp, region.find(item => item[currentTag] !== undefined)?.[currentTag]);
                // console.log("result:::: ", result, angle, bbox, xData, yData, currentRegion);
                // if (bbox.length > 0 && getVideoFlag()) drawBoxWithDiv(bbox[0], bbox[1]);
                if (result === 0 && getCaptureFlag()) {
                    if (getVideoFlag()) setGuidanceText(getTranslateText("You're standing too close to the car. Kindly move back a bit."));
                    if (redLineVINcontainer.current && getVideoFlag()) {
                        redLineVINcontainer.current.style.bottom = "27%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "flex";
                        if (leftArrowGuidance.current && rightArrowGuidance.current) {
                            leftArrowGuidance.current.style.transform = "rotate(140deg)";
                            rightArrowGuidance.current.style.transform = "rotate(45deg)";
                        }
                    }
                }
                else if (result === 1 && getCheckSectionAllowFlag() && frameCount >= 5 && getVideoFlag() && getCaptureFlag()) {
                    setCaptureFlag(false);
                    setShowBox(false);
                    setLambdaResult(null);
                    setColor("green");
                    if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
                        if (rootRef.current) {
                            rootRef.current.unmount();
                            rootRef.current = null;
                        }
                        if (!rootRef.current) {
                            rootRef.current = ReactDOM.createRoot(
                                stencilImageDiv.current
                            );
                            rootRef.current.render(
                                <ComponentToRender strokeColor="#90EE90" />
                            );
                        }
                    }
                    setCheckSectionAllowFlag(false);
                    blurLumaLambda(newImgURL, inspectionId, clientId);
                    clearTimeout(timeout2);
                    if (startBtn.current) startBtn.current.style.display = "block";
                    setGuidanceText(getTranslateText("Please hold on. You are standing at the right distance. Please take a photo."));
                    if (redLineVINcontainer.current) {
                        redLineVINcontainer.current.style.bottom = "22%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                        if (stopHand.current) stopHand.current.style.display = "flex";
                    }
                }
                else if (result === 1 && getVideoFlag() && !getCheckSectionAllowFlag() && getCaptureFlag()) {
                    setCaptureFlag(false);
                    setShowBox(false);
                    setLambdaResult(null);
                    setColor("green");
                    if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
                        if (rootRef.current) {
                            rootRef.current.unmount();
                            rootRef.current = null;
                        }
                        if (!rootRef.current) {
                            rootRef.current = ReactDOM.createRoot(
                                stencilImageDiv.current
                            );
                            rootRef.current.render(
                                <ComponentToRender strokeColor="#90EE90" />
                            );
                        }
                    }
                    blurLumaLambda(newImgURL, inspectionId, clientId);
                    clearTimeout(timeout2);
                    if (startBtn.current) startBtn.current.style.display = "block";
                    setGuidanceText(getTranslateText("Please hold on. You are standing at the right distance. Please take a photo."));
                    if (redLineVINcontainer.current) {
                        redLineVINcontainer.current.style.bottom = "22%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                        if (stopHand.current) stopHand.current.style.display = "flex";
                    }
                }
                else if (result === 2 && getCaptureFlag()) {
                    if (getVideoFlag()) setGuidanceText(getTranslateText("You're standing too far from the car. Kindly move closer."));
                    if (redLineVINcontainer.current && getVideoFlag()) {
                        redLineVINcontainer.current.style.bottom = "27%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "flex";
                        if (leftArrowGuidance.current && rightArrowGuidance.current) {
                            leftArrowGuidance.current.style.transform = "rotate(-35deg)";
                            rightArrowGuidance.current.style.transform = "rotate(-145deg)";
                        }
                    }
                }
                else if (result === 3 && getCaptureFlag()) {
                    if (getVideoFlag()) setGuidanceText(getTranslateText("No car detected!. Please point toward the car"));
                    if (redLineVINcontainer.current && getVideoFlag()) {
                        redLineVINcontainer.current.style.bottom = "7%";
                        redLineVINcontainer.current.style.display = "flex";
                        if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                    }
                }
                else if (getVideoFlag() && getCaptureFlag()) {
                    if (getVideoFlag()) setGuidanceText("");
                    if (guidanceArrow.current) guidanceArrow.current.style.display = "none";
                    if (redLineVINcontainer.current) redLineVINcontainer.current.style.display = "none";
                }
                if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
            } catch (err) {
                let backendErrorPatterns = [
                    /gl.*lost/i,
                    /webgl.*context/i,
                    /compile.*shader/i,
                    /link.*shader/i,
                    /link.*program/i,
                    /vertex.*shader/i,
                    /fragment.*shader/i,
                    /failed.*shader/i,
                    /webgl.*error/i,
                    /webgpu/i,
                    /device.*lost/i,
                    /cannot.*create.*gpu/i,
                    /gpu.*error/i,
                    /wasm.*memory.*error/i,
                    /memory.*access/i,
                    /invalid.*memory/i,
                    /cpu.*execution.*failed/i,
                    /backend.*error/i,
                    /backend.*failure/i,
                    /tensor.*backend.*error/i,
                    /unexpected.*backend/i,
                ];
                // console.log("Model execution failed:", err.message);
                // console.log("tf.engine().backendName", tf.engine().backendName);
                if (backendErrorPatterns.some((regex) => regex.test(err.message))) {
                    const fallbackBackend =
                        tf.engine().backendName === "webgl" ? "webgpu" : "cpu";
                    const datas = await setBackendExternally(fallbackBackend);
                    if (datas) {
                        if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
                        tf.engine().endScope();
                    }
                } else {
                    if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
                    tf.engine().endScope();
                }
            }
        }
        else {
            if (getVideoFlag()) requestAnimationFrame(() => detectFrame(video, model));
        }
    };

    const modal = () => {
        if (
            getSubCompleted()
        ) {
            imageAnalysis();
            return;
        }
        if (!getSubMandatoryCompleted() || !getSubCompleted()) {
            patLogs(
                `clicked to submit button, Warning given to user some option is not completed`,
                inspectionId
            );
            if (modalRef && modalRef.current) modalRef.current.style.display = "flex";
            return;
        }
    };

    const arrangeCurrentBlockItem = async () => {
        // Find the index of currentTag in captureList
        let tempCurrentBlock = currentBlockItem;
        const currentTagIndex = captureList.indexOf(currentTag);

        if (currentTagIndex === -1) {
            //console.warn(`currentTag "${currentTag}" not found in captureList. Returning original currentBlockItem.`);
            return;
        }

        // Create a mapping from tag to the original item object for efficient lookup
        const tagToItemMap = new Map();
        tempCurrentBlock.forEach(item => {
            tagToItemMap.set(item.tag, item);
        });

        const rearrangedList = [];
        const n = captureList.length;

        // Start from the currentTag's position in captureList
        for (let i = 0; i < n; i++) {
            const indexInCaptureList = (currentTagIndex + i) % n;
            const tagToFind = captureList[indexInCaptureList];

            // Find the corresponding item from currentBlockItem using the tag
            const item = tagToItemMap.get(tagToFind);
            if (item) {
                rearrangedList.push(item);
            } else {
                // console.warn(`Item with tag "${tagToFind}" from captureList not found in currentBlockItem.`);
            }
        }
        return rearrangedList;
    }

    const imageNext = async () => {
        // patLogs(
        //   `tick button clicked image sent for uploading... and return to ${currentBlock.id}`,
        //   inspectionId
        // );
        if (stencilBoxRef?.current) {
            stencilBoxRef.current.style.display = "none";
        }
        setVideoFlag(false);
        setShowBox(false);
        let newList;
        if (rearrangeFlag) newList = await arrangeCurrentBlockItem();
        logBugs = true;
        reservedData = null;
        if (imageCaptured) return;
        cameraStarted = false;
        imgRef.current.style.display = "none";
        imageCaptured = true;
        window.stream = null;
        track.stop();
        let temp2 = subCondition;
        temp2[currentBlock.id][currentSubBlock] = "completed";
        setSubCondition(temp2);
        currentBlock.values.map((item) => {
            if (item.name === currentSubBlock && item.mandatory) {
                let temp3 = subMandatory;
                temp3[currentBlock.id][currentSubBlock] = "completed";
                setSubMandatory(temp3);
            }
        });
        addImageToList(image);
        //setKotakRecapSubSection(currentBlock["tag"], currentTag);
        setLog(`${currentTag} was captured`);
        //send image here----
        checkAll();
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            if (rearrangeFlag) {
                rearrangeFlag = false;
                sortBlock(newList);
            }
            else sortBlock(currentBlockItem);
        }
        else if (rearrangeFlag) {
            rearrangeFlag = false;
            setCurrentBlockItem(newList);
        }
        setCount1(count1 + 1);
        if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
            if (rootRef.current) {
                rootRef.current.unmount();
                rootRef.current = null;
            }
        }
        setShowOptions(true);
    };

    const sortBlock = (newList) => {
        let tempCurrentBlock = newList;
        const subMissingSet = new Set(subMissing);
        const subMandatoryMissingSet = new Set(mandatoryMissing);

        tempCurrentBlock.sort((a, b) => {
            const aMandatoryIncomplete = subMandatoryMissingSet.has(a.name);
            const bMandatoryIncomplete = subMandatoryMissingSet.has(b.name);

            const aIncomplete = subMissingSet.has(a.name);
            const bIncomplete = subMissingSet.has(b.name);

            // Sort by mandatory and incomplete status
            if (aMandatoryIncomplete && !bMandatoryIncomplete) return -1;
            if (!aMandatoryIncomplete && bMandatoryIncomplete) return 1;

            if (aMandatoryIncomplete && bMandatoryIncomplete) return 0;

            if (aIncomplete && !bIncomplete) return -1;
            if (!aIncomplete && bIncomplete) return 1;

            return 0;
        });
        setCurrentBlockItem(tempCurrentBlock);
    };


    const checkAll = () => {
        let tempSubCheck = true;
        let tempMandCheck = true;
        mandatoryMissing = [];
        subMissing = [];
        currentBlock.values.map(async (item) => {
            if (subCondition[currentBlock.id][item.name] === "pending") {
                tempSubCheck = false;
                subMissing.push(item.name);
            }
            if (item.mandatory) {
                if (subMandatory[currentBlock.id][item.name] === "pending") {
                    tempMandCheck = false;
                }
            }
        });

        if (tempSubCheck) {
            setSubCompleted(true);
        }
        if (tempMandCheck) {
            setSubMandatoryCompleted(true);
        }
    };

    const back = () => {
        // patLogs(
        //   `back button is clicked and return to ${currentBlock.id}`,
        //   inspectionId
        // );
        //if (detectionBox.current) detectionBox.current.style.display = "none !important";
        if (Object.keys(config).includes("showStencil") && config["showStencil"]) {
            if (rootRef.current) {
                rootRef.current.unmount();
                rootRef.current = null;
            }
        }
        currentSubBlock = "";
        if (timeout1) clearTimeout(timeout1);
        if (timeout2) clearTimeout(timeout2);
        if (timeOutInterval) clearTimeout(timeOutInterval);
        currentTag = "";
        setVideoFlag(false);
        setAngleFlag(true);
        setShowBox(false);
        imageCaptured = true;
        cameraStarted = false;
        window.stream = null;
        track.stop();
        setShowOptions(true);
    };

    const imageAnalysis = () => {
        finsh();
        alignment = false;
    };

    const finsh = async () => {
        if (!getSubMandatoryCompleted) return;
        patLogs(`${currentBlock.id} is completed`, inspectionId);
        cameraStarted = false;
        setVideoFlag(false);
        let temp = condition;
        if (currentBlock.mandatory) {
            let temp1 = mandatory;
            temp1[currentBlock.id] = "completed";
            setMandatory(temp1);
        }
        image = {};
        currentSubBlock = "";
        currentTag = "";
        imageCaptured = false;
        temp[currentBlock["id"]] = "completed";
        setAngleFlag(false);
        setLog(`${currentBlock["tag"]} was finished`);
        setSubCompleted(false);
        setSubMandatoryCompleted(false);
        setCondition(temp);
        setKotakRecapMenuSection(currentBlock["tag"]);
        setScreen("menu");
    };

    useEffect(() => {
        if (stencilBoxRef.current) {
            stencilBoxRef.current.style.display = "none";
        }
        setLandscape(land());
        checkAll();
        setCount1(count1 + 1);
        if (currentBlock["values"].length <= 3) {
            alignment = true;
        }
        imageCaptured = true;
        currentBlock["values"].map((e) => {
            if (e["name"].length > 14) {
                setReduce(true);
            }
        });
        if (process.env.REACT_APP_IMAGE_SLIDER) {
            sortBlock(currentBlockItem);
        }
    }, []);

    useEffect(() => {
        if (modalRef.current && modalRef.current.style.display === "flex") modalRef.current.style.display = "none";
        if (warningRef.current && warningRef.current.style.display === "flex") warningRef.current.style.display = "none";
    }, [showOptions]);

    return (
        <Fragment>
            {!isLandscape ? (
                <Rotate />
            ) : showOptions ? (
                <div className="process" style={{ position: "relative" }}>
                    <h2>{currentBlock["id"]}</h2>
                    <div className="process-main" style={{ display: "flex" }}>
                        <div
                            className="left-btn"
                            disabled={scrollX === 0}
                            onClick={() => slide(-200)}
                            style={alignment ? { display: "none" } : {}}
                        >
                            <img
                                src={leftArrow}
                                style={scrollX === 0 ? { opacity: "0.3" } : {}}
                            />
                        </div>
                        <div
                            className="process-steps"
                            ref={scrl}
                            onScroll={scrollCheck}
                            style={
                                alignment
                                    ? {
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100vw",
                                    }
                                    : {
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        width: "80vw",
                                        overflowX: "scroll",
                                        scrollBehavior: "smooth",
                                        alignItems: "center",
                                    }
                            }
                        >
                            {currentBlockItem.map((item, index) => {
                                if (
                                    subCondition[currentBlock.id][item.name] === "completed"
                                ) {
                                    return (
                                        <div key={index}>
                                            <div
                                                className="menu-options"
                                                style={reduce ? { fontSize: "10px" } : null}
                                            >
                                                {item["mandatory"] ? (
                                                    <h4
                                                        style={{
                                                            color:
                                                                getKotakRecaptureCase() &&
                                                                    getKotakRecapSubSection(
                                                                        currentBlock["tag"],
                                                                        item["tag"]
                                                                    )
                                                                    ? "rgb(0, 180, 160)"
                                                                    : config["colors"]["complete-block"],
                                                        }}
                                                        key={index}
                                                    >
                                                        {item["name"]}&#42;
                                                    </h4>
                                                ) : (
                                                    <h4
                                                        style={{
                                                            color:
                                                                getKotakRecaptureCase() &&
                                                                    getKotakRecapSubSection(
                                                                        currentBlock["tag"],
                                                                        item["tag"]
                                                                    )
                                                                    ? "rgb(0, 180, 160)"
                                                                    : config["colors"]["complete-block"],
                                                        }}
                                                        key={index}
                                                    >
                                                        {item["name"]}
                                                    </h4>
                                                )}
                                                <div
                                                    className="process-vin"
                                                    style={{
                                                        border:
                                                            getKotakRecaptureCase() &&
                                                                getKotakRecapSubSection(
                                                                    currentBlock["tag"],
                                                                    item["tag"]
                                                                )
                                                                ? "2px solid rgb(0, 180, 160)"
                                                                : `2px solid ${config["colors"]["complete-block"]}`,
                                                        opacity:
                                                            feedBackPopUp.current &&
                                                                feedBackPopUp.current.style.display === "flex"
                                                                ? ".5"
                                                                : "",
                                                    }}
                                                    onClick={() => {
                                                        if (
                                                            Object.keys(config).includes(
                                                                "recaptureAfterSubmit"
                                                            ) &&
                                                            config["recaptureAfterSubmit"] &&
                                                            getKotakRecaptureCase() &&
                                                            !getKotakRecapSubSection(
                                                                currentBlock["tag"],
                                                                item["tag"]
                                                            )
                                                        ) {
                                                            //patLogs(`${item["tag"]} is clicked`, inspectionId);
                                                            currentSubBlock = item["name"];
                                                            currentTag = item["tag"];
                                                            setShowOptions(false);
                                                            imageCaptured = false;
                                                            startCamera();
                                                            Object.keys(item).includes("cameraInstruction") &&
                                                                setInstructions(item["cameraInstruction"]);
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className="greenCircleTick"
                                                        style={
                                                            feedBackPopUp.current &&
                                                                feedBackPopUp.current.style.display === "flex"
                                                                ? { opacity: ".5" }
                                                                : {
                                                                    backgroundColor:
                                                                        getKotakRecaptureCase() &&
                                                                            getKotakRecapSubSection(
                                                                                currentBlock["tag"],
                                                                                item["tag"]
                                                                            )
                                                                            ? "rgb(0, 180, 160)"
                                                                            : "",
                                                                }
                                                        }
                                                    >
                                                        <img src={white_tick} alt="1232"></img>
                                                    </div>
                                                    <SafeImage src={item["image"]} alt="123" />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }
                                return (
                                    <div key={index}>
                                        <div
                                            className="menu-options"
                                            style={reduce ? { fontSize: "10px" } : null}
                                        >
                                            {item["mandatory"] ? (
                                                <h4 key={index}>{item["name"]}&#42;</h4>
                                            ) : (
                                                <h4 key={index}>{item["name"]}</h4>
                                            )}
                                            <div
                                                className="process-vin"
                                                style={{
                                                    border: `1px solid ${config["colors"]["incomplete-block"]}`,
                                                }}
                                                onClick={() => {
                                                    if (getCheckSectionAllowFlag()) {
                                                        if (!allowSectionAtFirst.includes(index)) {
                                                            if (warningRef.current) warningRef.current.style.display = "flex";
                                                            return;
                                                        }
                                                    }
                                                    //patLogs(`${item["tag"]} is clicked`, inspectionId);
                                                    currentSubBlock = item["name"];
                                                    currentTag = item["tag"];
                                                    setShowOptions(false);
                                                    imageCaptured = false;
                                                    startCamera();
                                                    Object.keys(item).includes("cameraInstruction") &&
                                                        setInstructions(item["cameraInstruction"]);



                                                }}
                                            >
                                                <SafeImage src={item["image"]} alt="123" />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            className="right-btn"
                            disabled={scrolEnd}
                            style={alignment ? { display: "none" } : {}}
                            onClick={() => slide(+200)}
                        >
                            <img
                                src={rightArrow}
                                style={scrolEnd ? { opacity: "0.3" } : {}}
                            />
                        </div>
                    </div>
                    {
                        showAlert && <div className="InternetWarning">
                            <p>{showAlert && showAlert}</p>
                        </div>
                    }
                    <div
                        className="modal-btn-container-multipleImage"
                        style={{ display: "flex", backgroundColor: "#F8F7FC" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignContent: "center",
                                width: "100%",
                            }}
                        >
                            <Button
                                secoundaryBtn="true"
                                text={config["multiple-image-page"]["back-btn-text"]}
                                onclick={goBack}
                                marginDefault="0px 0px 0px 0px"
                            />
                            <Button
                                text={config["multiple-image-page"]["next-btn-text"]}
                                disabled={
                                    !getSubMandatoryCompleted()
                                }
                                onclick={() => {
                                    modal();
                                }}
                                marginDefault="0px 25px 0px 25px"
                            />
                        </div>
                    </div>
                    <div
                        ref={warningRef}
                        className="menu-modal-container"
                        style={{ display: "none" }}
                    >
                        <div className="menu-modal-warning">
                            <h3>{getTranslateText("To proceed, please start with any first 4 sections")}</h3>
                            <div className="modal-btn-container">
                                <Button
                                    text={getTranslateText("Ok got it")}
                                    onclick={() => {
                                        if (warningRef.current) warningRef.current.style.display = "none"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        ref={modalRef}
                        className="menu-modal-container"
                        style={{ display: "none" }}
                    >
                        {!getSubMandatoryCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["mandatory-modal-text"]}</h4>
                                <h4>{mandatoryMissing.join(", ")}</h4>
                            </div>
                        ) : getSubMandatoryCompleted() && !getSubCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["optional-modal-text"]}</h4>
                                <h4>{subMissing.join(", ")}</h4>
                                <div className="modal-btn-container">
                                    <Button
                                        text={config["multiple-image-page"]["modal-btn-next"]}
                                        onclick={() => {
                                            setStepCovered([...stepCovered]);
                                            patLogs(
                                                `Warning given to user some module is not completed still user clicked final submit button`,
                                                inspectionId
                                            );
                                            imageAnalysis();
                                        }}
                                    />
                                </div>
                            </div>
                        ) : getSubCompleted() ? (
                            <div className="menu-modal">
                                <div className="menu-back-btn">
                                    <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                                </div>
                                <h4>{config["multiple-image-page"]["back-modal-text"]}</h4>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div id="vin-screen" ref={singleScreen}>
                    <canvas
                        ref={canvasRef}
                        id="ios-canvas"
                        style={
                            getAspectRatioClientList(clientId, config)
                                ? {
                                    width: "100vw",
                                    height: "100vh",
                                    objectFit: "contain",
                                    backgroundColor: "black",
                                }
                                : {}
                        }
                    ></canvas>
                    <div
                        style={{ width: "100dvw", height: "100dvh", position: "absolute" }}
                    >
                        <video
                            ref={videoRef}
                            id="videoWindow"
                            style={
                                getAspectRatioClientList(clientId, config)
                                    ? {
                                        width: "100vw",
                                        height: "100vh",
                                        objectFit: "contain",
                                        backgroundColor: "black",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                    }
                                    : { position: "absolute", top: 0, left: 0 }
                            }
                            autoPlay
                            playsInline
                        ></video>
                        {
                            (Object.keys(config).includes("showStencil") && config["showStencil"]) && <div className="stencil" ref={stencilImageDiv}></div>
                            // config["showStencil"] && 
                            // <div
                            //     className="stencilBox"
                            //     ref={stencilBoxRef}
                            //     style={{
                            //         position: "absolute"
                            //     }}
                            // >
                            //     <div
                            //         alt=""
                            //         style={
                            //             /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                            //                 !window.MSStream
                            //                 ? {
                            //                     width: "90%",
                            //                     height: "90%",
                            //                     objectFit: "contain",
                            //                 }
                            //                 : { width: "100%", height: "100%", objectFit: "contain" }
                            //         }
                            //     >
                            //         {
                            //             renderRegion()
                            //             // region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Front" ? <Front strokeColor={color} /> :
                            //             //     region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Front-Isometric-Left" ? <Front_Isometric_Left strokeColor={color} /> :
                            //             //         region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Side-Left" ? <Side_Left strokeColor={color} /> :
                            //             //             region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Rear-Isometric-Left" ? <Rear_Isometric_Left strokeColor={color} /> :
                            //             //                 region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Rear" ? <Rear strokeColor={color} /> :
                            //             //                     region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Rear-Isometric-Right" ? <Rear_Isometric_Right strokeColor={color} /> :
                            //             //                         region.find(item => item[currentTag] !== undefined)?.[currentTag] === "Side-Right" ? <Side_Right strokeColor={color} /> : <Front_Isometric_Right strokeColor={color} />
                            //         }
                            //     </div>
                            // </div>
                        }
                        <div style={{ position: "relative", height: "100vh", width: "100vw" }} ref={detectionBox}></div>
                        <p
                            style={{
                                position: "absolute",
                                top: "30px",
                                left: 0,
                                backgroundColor: "white",
                                padding: "5px",
                            }}
                            ref={partData}
                        ></p>
                    </div>
                    <p ref={pRef} style={{ fontSize: "12px", display: "none" }} className="pTag"></p>
                    <div ref={noFeedbackPop} className="imageFeedBackCompletePopup" style={{ display: "none" }}>
                        <div className="imageFeedBackInnerDiv" style={{ zIndex: 5 }}>
                            <p>{getTranslateText("Captured image looks good. Want to retake or continue?")}</p>
                            <div className="modal-btn-container" style={{ paddingRight: "unset" }}>
                                <Button
                                    secoundaryBtn={"true"}
                                    text={getTranslateText("Retake")}
                                    onclick={imageRetake}
                                />
                                <Button
                                    text={Object.keys(config["video-page"]).includes("continueText") ? config["video-page"]["continueText"] : getTranslateText("Continue")}
                                    onclick={imageNext}
                                />
                            </div>
                        </div>
                    </div>
                    <div ref={feedBackPopUp} className="imageFeedBackPopup">
                        <div style={{ zIndex: 5, height: "unset", minHeight: "50vh", position: "fixed", top: "15%" }}>
                            <p style={{ fontSize: "16px", fontWeight: 700, margin: "0px", padding: "1%" }} ref={feedbackHeadText}></p>
                            {
                                feedback.length === 0 && !resultFlag ? (
                                    <div
                                        id="zizo-loader"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img
                                            style={{ zIndex: 5, position: "fixed", width: "8%" }}
                                            src={car_inspection}
                                        />
                                        <img style={{ width: "25%" }} src={loading}></img>
                                    </div>
                                ) : (
                                    resultFlag && feedback.length > 0 && (
                                        <div
                                            style={{
                                                justifyContent: "space-around",
                                                textAlign: "left",
                                                height: "45vh",
                                                zIndex: 5,
                                            }}
                                        >
                                            <h4 style={{ margin: "0px" }}>
                                                {Object.keys(config).includes("imageFeedback") &&
                                                    Object.keys(config["imageFeedback"]).includes("ReasonTxt")
                                                    ? config["imageFeedback"]["ReasonTxt"]
                                                    : getTranslateText("Reason")}
                                            </h4>
                                            <ul style={{ margin: "0px" }}>
                                                {feedback.map((e) => {
                                                    return (
                                                        <li style={{ padding: "2px 0px" }}>
                                                            {e}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            <button
                                                className="feedbackbtn"
                                                style={{
                                                    backgroundColor: config["colors"]["btn"],
                                                    fontSize: "18px",
                                                }}
                                                onClick={imageRetake}
                                            >
                                                {Object.keys(config).includes("imageFeedback") &&
                                                    Object.keys(config["imageFeedback"]).includes(
                                                        "RecaptureBtnTxt"
                                                    )
                                                    ? config["imageFeedback"]["RecaptureBtnTxt"]
                                                    : getTranslateText("Recapture image")}
                                            </button>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                    <div
                        className="redLineVINcontainerView"
                        style={{
                            position: "absolute",
                            bottom: "5%",  //18
                            height: "7%",
                            justifyContent: "flex-start",
                            width: "100%"
                        }}
                        ref={redLineVINcontainer}
                    >
                        <div id="hand" ref={stopHand}>
                            <img src={hand} alt="123" style={{ width: "6dvw" }} />
                        </div>
                        <div id="arrow" ref={guidanceArrow}>
                            <img id="arrowLeft" ref={leftArrowGuidance} src={zizo_arrow} alt="123" />
                            <img id="arrowRight" ref={rightArrowGuidance} src={zizo_arrow} alt="123" />
                        </div>
                        <div className="guidanceDiv">
                            <p id="feedbackGuidance">{guidanceText}</p>
                        </div>
                    </div>
                    <div
                        ref={startBtn}
                        style={{
                            backgroundImage: `url(${cameraImg})`,
                            backgroundSize: "37px 37px",
                            backgroundRepeat: "no-repeat",
                            objectFit: "cover",
                            backgroundPosition: "center",
                        }}
                        onClick={captureImg}
                        id="btn-vin-start"
                    ></div>
                    <div className="back-btn">
                        <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
                    </div>
                    <div ref={cardRef} id="display-card-zizo">
                        <div id="zizo-loader-text" style={{ textAlign: "center" }}>
                            <h3>{config["video-page"]["loadingText"]}</h3>
                        </div>
                        <div
                            id="zizo-loader"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img src={car_inspection} alt="123" style={{ zIndex: 5, position: "fixed", width: "8%" }} />
                            <img style={{ width: "60%" }} src={loading}></img>
                        </div>
                    </div>
                    {instructions && (
                        <div className="camerInst">
                            <p>{instructions}</p>
                        </div>
                    )}
                    <div
                        id="vin-image"
                        style={
                            getAspectRatioClientList(clientId, config)
                                ? { backgroundColor: "black", objectFit: "contain" }
                                : {}
                        }
                        ref={imgRef}
                    >
                        <p ref={pTagRef} className="pTag"></p>
                        <img
                            ref={divImgRef}
                            style={
                                getAspectRatioClientList(clientId, config)
                                    ? { objectFit: "contain" }
                                    : { width: "100vw", height: "100vh" }
                            }
                        />
                        <div style={{ display: "none" }} ref={imageContainer}>
                            <i
                                className="fas fa-times fa-2x vin-btn-retake"
                                onClick={imageRetake}
                            ></i>
                            <i
                                className="fas fa-check fa-2x vin-btn-next"
                                onClick={imageNext}
                            ></i>
                        </div>
                    </div>
                </div>
            )
            }
        </Fragment >
    );
};


export default NewImgApp;

